module.exports = __webpack_public_path__ + "img/2.Παξοί-min.565b6778.jpg";